import Vue from 'vue'
import Router from 'vue-router'
//注册
import Register from '@/views/register'
//登录
import Login from '@/views/login'
//需求发布
import Release from '@/views/release'
//用户中心
import UserCenter from '@/views/user-center'
//关于超市
import AboutUs from '@/views/about-us'
//首页
import Index from '@/views/index'
//双创政策
import Policy from '@/views/policy'
import PolicyDetail from '@/views/policy-detail'
//载体频台
import Supporter from '@/views/supporter'
import SupporterDetail from '@/views/supporter-detail'
//专家导师
import Expert from '@/views/expert'
import ExpertDetail from '@/views/expert-detail'
//双创项目
import Project from '@/views/project'
import ProjectDetail from '@/views/project-detail'
//技术成果
import Achievement from '@/views/achievement'
import AchievementDetail from '@/views/achievement-detail'

//9-25号修改之后金融创投
import Carrier from '@/views/carrier'
import CarrierDetail from '@/views/carrier-detail'

//通知
import Notice from '@/views/notice'
import NoticeDetail from '@/views/notice-detail'
//平台大事
import PlatformEvents from '@/views/platformEvents'
import PlatformEventsDetail from '@/views/platformEvents-detail'
//双创活动
import Activity from '@/views/activity'
import ActivityDetail from '@/views/activity-detail'
import ActivityOrderDetail from '@/views/activity-order-detail'
//服务产品
import Product from '@/views/product'
import ProductDetail from '@/views/product-detail'
//高技术人才
import Person from '@/views/person'
import PersonDetail from '@/views/person-detail'
//订单详情
import orderDetail from '@/views/orderDetail'

import Error404 from '@/views/404'

Vue.use(Router)
//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  base: '/sovo/',
  mode: 'history',
  // mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
	{
		path: '/index',
		name: 'index',
		component: Index
	},
	{
		path: '/register',
		name: 'register',
		component: Register
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/release',
		name: 'release',
		component: Release
	},
	{
		path: '/userCenter',
		name: 'userCenter',
		component: UserCenter
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: AboutUs
	},
	{
		path: '/policy',
		name: 'policy',
		component: Policy,	
	},
	{
		path: '/policyDetail',
		name: 'policyDetail',
		component: PolicyDetail,
	},
	{
		path: '/supporter',
		name: 'supporter',
		component: Supporter,
	},
	{
		  path: '/supporterDetail',
		  name: 'supporterDetail',
		  component: SupporterDetail
	},
	{
		path: '/expert',
		name: 'expert',
		component: Expert,
	},
	{
		path: '/expertDetail',
		name: 'expertDetail',
		component: ExpertDetail,
	},
	{
		path: '/project',
		name: 'project',
		component: Project,
	},
	{
		path: '/projectDetail',
		name: 'projectDetail',
		component: ProjectDetail,
	},{
		path: '/orderDetail',
		name: 'orderDetail',
		component: orderDetail,
	},
	{
		path: '/achievement',
		name: 'achievement',
		component: Achievement,
	},
	{
		path: '/achievementDetail',
		name: 'achievementDetail',
		component: AchievementDetail
	},
	{
		path: '/carrier',
		name: 'carrier',
		component: Carrier,
	},
	{
		path: '/carrierDetail',
		name: 'carrierDetail',
		component: CarrierDetail,
	},
	{
		path: '/notice',
		name: 'notice',
		component: Notice,
	},
	{
		path: '/noticeDetail',
		name: 'noticeDetail',
		component: NoticeDetail,
	},
	{
		path: '/platformEvents',
		name: 'platformEvents',
		component: PlatformEvents,
	},
	{
		path: '/platformEventsDetail',
		name: 'platformEventsDetail',
		component: PlatformEventsDetail,
	},
	{
		path: '/activity',
		name: 'activity',
		component: Activity,
	},
	{
		path: '/activityDetail',
		name: 'activityDetail',
		component: ActivityDetail,
	},
	{
		path: '/activityOrderDetail',
		name: 'activityOrderDetail',
		component: ActivityOrderDetail,
	},
	{
		path: '/product',
		name: 'product',
		component: Product,
	},
	{
		path: '/productDetail',
		name: 'productDetail',
		component: ProductDetail,
	},
	{
		path: '/person',
		name: 'person',
		component: Person,
	},
	{
		path: '/personDetail',
		name: 'personDetail',
		component: PersonDetail,
	},
	{ 
	    path: '*', 
	    component: Error404
	  }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js